import { Input, InputRef, Space, Tag, Button } from 'antd'
import { CloseOutlined, PlusOutlined } from '@ant-design/icons'
import { FC, useEffect, useRef, useState } from 'react'
import { LoyaltyTag } from '../../models/LoyaltyTier'
import {
  createLoyaltyTag,
  deleteLoyaltyTag,
} from '../../services/LoyaltyTiersService'
import { ButtonColorType } from 'antd/es/button'
import { useHasAccess } from '../HasAccess'
import { Permission } from '../../utils/permissions'

type Props = {
  tags: LoyaltyTag[]
  color: ButtonColorType
  loyaltyTierProviderId: number
  onTagsChange: () => void
}

const LoyaltyTierTagList: FC<Props> = ({
  tags,
  color,
  loyaltyTierProviderId,
  onTagsChange,
}) => {
  const [inputVisible, setInputVisible] = useState<boolean>(false)
  const [inputValue, setInputValue] = useState<string>('')
  const inputRef = useRef<InputRef>(null)
  const { hasAccess } = useHasAccess()

  const showInput = () => {
    setInputVisible(true)
  }

  const handleInputConfirm = () => {
    if (!inputValue) {
      return
    }
    createLoyaltyTag(inputValue, loyaltyTierProviderId).then(() => {
      setInputVisible(false)
      setInputValue('')
      onTagsChange()
    })
  }

  useEffect(() => {
    if (inputVisible) {
      inputRef.current?.focus()
    }
  }, [inputVisible])

  return (
    <Space wrap>
      {tags.map((tag) => (
        <Tag
          key={tag.id}
          color={color}
          closeIcon={
            hasAccess(Permission.updateLoyaltyTier) && (
              <CloseOutlined
                style={{ color: color }}
                onClick={() => {
                  if (tag.id) {
                    deleteLoyaltyTag(tag.id).then(() => onTagsChange())
                  }
                }}
              />
            )
          }
        >
          {tag.name}
        </Tag>
      ))}
      {hasAccess(Permission.updateLoyaltyTier) &&
        (inputVisible ? (
          <Space.Compact>
            <Input
              ref={inputRef}
              type="text"
              size="small"
              style={{ width: 80 }}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onPressEnter={handleInputConfirm}
            />
            {
              <Button size="small" type="primary" onClick={handleInputConfirm}>
                Add
              </Button>
            }
          </Space.Compact>
        ) : (
          <Tag
            color={color}
            onClick={showInput}
            style={{ borderStyle: 'dashed' }}
          >
            <PlusOutlined /> Add Tag
          </Tag>
        ))}
    </Space>
  )
}

type TagListType = { TagList: typeof LoyaltyTierTagList }

export { LoyaltyTierTagList, type TagListType }
